<div class="bg-background min-h-screen flex flex-col items-center justify-center px-4 relative overflow-hidden">
    <!-- Architectural Background Gradients -->
    <div class="absolute top-0 left-0 w-full h-full pointer-events-none opacity-20">
        <div class="absolute top-[-10%] right-[-10%] w-[600px] h-[600px] rounded-full bg-primary-container/30 blur-[120px]"></div>
        <div class="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-secondary-container/20 blur-[120px]"></div>
    </div>

    <!-- Brand Header -->
    <div class="mb-12 relative z-10 text-center">
        <a routerLink="/" class="text-3xl font-extrabold tracking-tight text-primary brand-logo">ZAD ERP</a>
    </div>

    <!-- Main Card -->
    <div class="w-full max-w-[540px] bg-surface-container-lowest rounded-xl p-10 ambient-shadow relative z-10 text-center border border-outline-variant/10">
        
        <!-- Verifying State -->
        <div *ngIf="isVerifying" class="flex flex-col items-center justify-center py-8">
            <span class="material-symbols-outlined text-5xl text-primary animate-spin mb-4">refresh</span>
            <h2 class="text-xl font-bold text-on-surface">Verifying your email...</h2>
        </div>

        <!-- Error State -->
        <div *ngIf="!isVerifying && verificationFailed" class="flex flex-col items-center justify-center">
            <div class="w-20 h-20 bg-error/10 rounded-2xl flex items-center justify-center mx-auto mb-8">
                <span class="material-symbols-outlined text-4xl text-error">error</span>
            </div>
            <h1 class="text-2xl font-bold text-on-surface mb-4 tracking-tight">Verification Failed</h1>
            <p class="text-on-surface-variant leading-relaxed mb-10">{{ errorMessage || 'The verification link may be expired or invalid.' }}</p>
            <div class="mt-4 pt-6 border-t border-outline-variant/15 text-center w-full">
                <a routerLink="/contact" class="text-primary font-bold hover:underline">Contact Support</a>
            </div>
        </div>

        <!-- Success State -->
        <div *ngIf="!isVerifying && !verificationFailed" class="flex flex-col items-center justify-center">
            <!-- Icon Header -->
            <div class="w-20 h-20 bg-primary-container/20 rounded-2xl flex items-center justify-center mx-auto mb-8">
                <span class="material-symbols-outlined text-4xl text-primary">verified</span>
            </div>

            <h1 class="text-2xl font-bold text-on-surface mb-4 tracking-tight">Email Verified!</h1>
            
            <p class="text-on-surface-variant leading-relaxed text-lg font-medium mb-10 px-4">
                Your platform is being prepared and will be ready within 24 hours. We will notify you as soon as it's live.
            </p>

            <!-- Actions -->
            <div class="flex flex-col gap-4 w-full">
                <a routerLink="/" class="w-full py-4 bg-primary-container text-on-primary font-bold text-lg rounded-xl shadow-lg hover:shadow-primary/20 transition-all active:scale-95 block">
                    Return to Homepage
                </a>
            </div>
        </div>

    </div>

    <!-- Footer Copyright -->
    <footer class="mt-12 w-full max-w-[540px] text-center">
        <p class="text-xs text-outline font-medium tracking-tight">
            &copy; 2026 ZAD ERP. All rights reserved.
        </p>
    </footer>
</div>
